import { useCallback } from 'react'
import { FormikHelpers } from 'formik'

import { ICallTrackingAccount } from '../typings'
import { snackMachine, useIsUnmounted } from '@sales-center/components'
import { useAppDispatch } from '@user/store/hooks/useAppDispatch'
import {
  getCallTrackingProviders,
  syncCallTracking,
} from '@user/store/callTracking'

export function useSyncHandler() {
  const dispatch = useAppDispatch()
  const isUnmounted = useIsUnmounted()

  const errorMessage = 'Invalid Account Id, Access Key, and/or Secret Key.'

  const handleSubmit = useCallback(
    async (
      model: ICallTrackingAccount,
      helpers: FormikHelpers<ICallTrackingAccount>,
    ) => {
      const result = await dispatch(syncCallTracking(model))
      if (isUnmounted()) return
      if (!syncCallTracking.fulfilled.match(result)) {
        helpers.setStatus({
          error: true,
          message: errorMessage,
          synced: false,
        })
        snackMachine.addSnack({
          severity: 'error',
          message: '',
          title: errorMessage,
        })
      } else {
        await dispatch(getCallTrackingProviders())
        helpers.setStatus({ error: false, synced: true })
      }
    },
    [dispatch, isUnmounted],
  )

  return {
    handleSubmit,
  }
}
